export default "__VITE_ASSET__CZAzPT$i__"